import React, { useState, useEffect } from 'react';
import AdminLayout from '../../components/AdminLayout';
import { FileText, Calendar, Users, MapPin } from 'lucide-react';

const QuoteRequests = () => {
  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchQuotes();
  }, []);

  const fetchQuotes = async () => {
    try {
      const token = localStorage.getItem('adminToken');
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/admin/quotes`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setQuotes(data);
      }
    } catch (error) {
      console.error('Erreur:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = async (quoteId, newStatus) => {
    try {
      const token = localStorage.getItem('adminToken');
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/admin/quotes/${quoteId}/status?status=${newStatus}`,
        {
          method: 'PUT',
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );

      if (response.ok) {
        fetchQuotes();
      }
    } catch (error) {
      console.error('Erreur:', error);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'En attente': return '#2c5f7d';
      case 'Traité': return '#8b4f6d';
      case 'Refusé': return '#c41e3a';
      default: return '#666';
    }
  };

  const formatDate = (dateString) => {
    try {
      return new Date(dateString).toLocaleDateString('fr-FR');
    } catch {
      return dateString;
    }
  };

  return (
    <AdminLayout>
      <div style={{ padding: '32px' }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '32px'
        }}>
          <h1 className="hero-medium">Demandes de Devis</h1>
        </div>

        {loading ? (
          <p>Chargement...</p>
        ) : quotes.length === 0 ? (
          <div style={{
            padding: '48px',
            textAlign: 'center',
            background: 'var(--bg-primary)',
            border: '1px solid var(--border-light)'
          }}>
            <FileText size={48} style={{ color: 'var(--text-secondary)', margin: '0 auto 16px' }} />
            <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
              Aucune demande de devis pour le moment
            </p>
          </div>
        ) : (
          <div style={{ display: 'grid', gap: '16px' }}>
            {quotes.map((quote) => (
              <div
                key={quote.id}
                style={{
                  background: 'var(--bg-primary)',
                  border: '1px solid var(--border-light)',
                  padding: '24px'
                }}
              >
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'flex-start',
                  marginBottom: '16px'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <span style={{
                      padding: '6px 14px',
                      background: getStatusColor(quote.status),
                      color: '#fff',
                      fontSize: '12px',
                      fontWeight: 600
                    }}>
                      {quote.status}
                    </span>
                    <span className="body-small" style={{ color: 'var(--text-secondary)' }}>
                      {quote.trip_type}
                    </span>
                  </div>
                  
                  <select
                    value={quote.status}
                    onChange={(e) => handleStatusChange(quote.id, e.target.value)}
                    style={{
                      padding: '8px 12px',
                      border: '1px solid var(--border-light)',
                      fontSize: '13px',
                      cursor: 'pointer',
                      background: 'var(--bg-secondary)'
                    }}
                  >
                    <option value="En attente">En attente</option>
                    <option value="Traité">Traité</option>
                    <option value="Refusé">Refusé</option>
                  </select>
                </div>

                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                  gap: '16px'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <MapPin size={18} color="var(--text-secondary)" />
                    <div>
                      <p className="body-small" style={{ color: 'var(--text-secondary)' }}>Trajet</p>
                      <p className="body-regular">{quote.departure} → {quote.arrival}</p>
                    </div>
                  </div>

                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <Calendar size={18} color="var(--text-secondary)" />
                    <div>
                      <p className="body-small" style={{ color: 'var(--text-secondary)' }}>Date & Heure</p>
                      <p className="body-regular">{quote.date} à {quote.time}</p>
                    </div>
                  </div>

                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <Users size={18} color="var(--text-secondary)" />
                    <div>
                      <p className="body-small" style={{ color: 'var(--text-secondary)' }}>Passagers</p>
                      <p className="body-regular">{quote.passengers}</p>
                    </div>
                  </div>

                  {quote.created_at && (
                    <div>
                      <p className="body-small" style={{ color: 'var(--text-secondary)' }}>Reçu le</p>
                      <p className="body-regular">{formatDate(quote.created_at)}</p>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}

        <p className="body-small" style={{ marginTop: '16px', color: 'var(--text-secondary)' }}>
          {quotes.length} demande(s) de devis
        </p>
      </div>
    </AdminLayout>
  );
};

export default QuoteRequests;